import React from 'react';
import './styles.scss';
import { Spinner } from 'react-bootstrap';
import Button from '../../../components/molecules/buttons';
import { Discount as DiscountIcon } from '../../../components/atoms/icons';
import Card from '../../../components/molecules/cards';
import usePartners from './hooks';
import LandingHeader from '../../../components/layout/header/landing';

function Partners() {
  const {
    isLoading, partnerList, onNavigateToDetail, onNavigateAddPartner,
  } = usePartners();

  return (
    <div className="py-4">
      <LandingHeader title="Partners" />
      <div className="px-4 px-xl-5">
        <div className="d-flex justify-content-end mb-4" style={{ height: '42px' }}>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="addPartners"
              type="button"
              label="Add Partners"
              onClick={() => onNavigateAddPartner()}
            />
          </div>
        </div>
        <div className="w-100">
          <div className="row">
            {(() => {
              if (isLoading) {
                return (
                  <div className="w-100 flexible-center">
                    <Spinner animation="border" />
                  </div>
                );
              }
              if (partnerList && partnerList.length) {
                return partnerList.map((partner) => (
                  <div key={partner.id} className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-2">
                    <Card.Driver
                      title={partner.name}
                      name={`$${partner.comission ?? 0}`}
                      id={partner.id}
                      icon={<DiscountIcon width={16} />}
                      onClick={() => onNavigateToDetail(partner.id.toString())}
                    />
                  </div>
                ));
              }
              return (
                <div className="text-center">Data Not Found</div>
              );
            })()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Partners;
